import React, { useState } from "react";
import {
  Box,
  Grid,
  VStack,
  Text,
  Flex,
  Icon,
  IconButton,
  HStack,
  Image,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Checkbox,
  Tbody,
  Td,
  Spinner,
} from "@chakra-ui/react";
import { deleteModelApi } from "../../../allApi/api";
import DownloadJsonFile from "../../../components/DownLoadBtn/DownloadJsonFile";
import DownloadJsonFileList from "../../../components/DownLoadBtn/DownLoadinList";
import deleteBtn from "../../../assets/waveflowmain/deleteBtn.png";
import deleteBlueBtn from "../../../assets/waveflowmain/deleteBluebTn.png";
import downloadBtnCopy from "../../../assets/waveflowmain/downloadBtnCopy.png";
import together from "../../../assets/modelsIcon/together.png";
import groqIcon from "../../../assets/modelsIcon/groqIcon.png";
import openAiLogo from "../../../assets/modelsIcon/openAiLogo.png";
import mistralIcon from "../../../assets/modelsIcon/mistralIcon.png";
import deepseek from "../../../assets/modelsIcon/deepseek.png";
import gemini from "../../../assets/modelsIcon/gemini.png";
import aibedStrok from "../../../assets/modelsIcon/aibedStrok.png";
import { AiOutlineClockCircle } from "react-icons/ai";
import { commonStyle } from "../../../styles/commonStyle";
import { clearModelFetch } from "../../../redux/reducer/toolsmodel";

const Card = ({ title, model, date, modelId, modelJson, onDelete }) => {
  const [deleteLoader, setDeleteLoader] = useState(false);

  const handleDelete = async () => {
    setDeleteLoader(true);
    await onDelete(modelId);
    setDeleteLoader(false);
  };

  return (
    <Box bg="gray.50" border="none" borderRadius="20px" p={3} h={"200px"} boxShadow="md">
      <VStack align="flex-start" spacing={2} w="full" h="full">
        <Box w="full" h="full" minH="150px" display="flex" flexDirection="column" justifyContent="space-between">
          <VStack align="flex-start" textAlign="left" gap={0}>
            <HStack mb={3} spacing={2}>
              <Image
                src={
                  title == "together"
                    ? together
                    : title == "groq"
                    ? groqIcon
                    : title == "OpenAI"
                    ? openAiLogo
                    : title == "mistral"
                    ? mistralIcon
                    : title == "deepseek"
                    ? deepseek
                    : title == "gemini"
                    ? gemini
                    : title == "AWS Bedrock"
                    ? aibedStrok
                    : ""
                }
              />
              <Text fontWeight="bold">{title}</Text>
            </HStack>
            <Text fontSize="sm" color="gray.500">
              Model Name
            </Text>
            <Text fontSize="sm" color="gray.700">
              {model}
            </Text>
            <Flex align="center" mt={2} justifyContent="space-between">
              <Flex align="center">
                <Icon as={AiOutlineClockCircle} color="gray.500" mr={2} />
                <Text fontSize="xs" color="gray.500">
                  {date}
                </Text>
              </Flex>
            </Flex>
          </VStack>
          <Box w="full">
            <HStack p={0} spacing={0} justifyContent="flex-end">
              {deleteLoader ? (
                <Spinner thickness="2px" speed="0.65s" color="gray.500" size="sm" />
              ) : (
                <IconButton
                  onClick={handleDelete}
                  icon={<Image src={deleteBtn} alt="delete" w="20px" />}
                  size="sm"
                  colorScheme="red"
                  variant="ghost"
                  aria-label="Delete item"
                />
              )}
              <DownloadJsonFile dataDownload={modelJson} />
            </HStack>
          </Box>
        </Box>
      </VStack>
    </Box>
  );
};

export const CardGrid = ({ modelList, onDelete }) => {
  const handleDelete = async (modelId) => {
    await deleteModelApi(modelId);
    onDelete(modelId);
  };

  return (
    <Grid w="100%" m="auto" templateColumns="repeat(4, 1fr)" gap={6} p={4} h={"70vh"} border={"1px solid lightgray"} overflowY="auto">
      {modelList.map((card) => (
        <Card
          key={card.id}
          title={card.client}
          model={card.model_name}
          date={card.date}
          modelId={card.id}
          modelJson={card}
          onDelete={handleDelete}
        />
      ))}
    </Grid>
  );
};

export const ModelList = ({ modelList, onDelete }) => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const handleDelete = async (modelId) => {
    await deleteModelApi(modelId);
    onDelete(modelId);
  };

  const truncateText = (text, charLimit) =>
    text?.length > charLimit ? text.slice(0, charLimit) + "..." : text;

  return (
    <Box w="100%" overflowY="auto" maxH="500px">
      <TableContainer w="100%" m="auto" maxH="500px" overflowY="auto">
        <Table size="sm">
          <Thead position="sticky" top={0} bg="white" zIndex={1}>
            <Tr>
              <Th>
                <Checkbox />
              </Th>
              <Th>Model</Th>
              <Th>Provider</Th>
              <Th>API Base URL</Th>
              <Th>Description</Th>
              <Th>Created On</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {modelList.map((row, index) => (
              <Tr
                key={row.id}
                onMouseEnter={() => setHoveredRow(index)}
                onMouseLeave={() => setHoveredRow(null)}
                _hover={{ bg: "gray.50" }}
              >
                <Td>
                  <Checkbox />
                </Td>
                <Td>{row.model_name}</Td>
                <Td>{row.client}</Td>
                <Td>{truncateText(row.base_url, 30)}</Td>
                <Td>{truncateText(row.description, 50)}</Td>
                <Td>{row.date}</Td>
                <Td>
                  <Flex alignItems="center" gap={2}>
                    <DownloadJsonFileList dataDownload={row} />
                    <IconButton
                      onClick={() => handleDelete(row.id)}
                      icon={
                        <Image
                          src={hoveredRow === index ? deleteBlueBtn : deleteBtn}
                          alt="delete"
                          w="20px"
                        />
                      }
                      size="sm"
                      colorScheme="red"
                      variant="ghost"
                      aria-label="Delete item"
                    />
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
